module.exports = __webpack_public_path__ + "img/ionodes.fe9083f9.png";